import React from "react";
import { BriefcaseBusiness, Home, Languages, LayoutDashboard, LogOut, MailCheck } from "lucide-react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { useLanguage } from "../../i18n/LanguageContext";

const UserSidebar = ({ open = false, onClose }) => {
  const navigate = useNavigate();
  const { isEnglish, toggleLanguage } = useLanguage();
  const links = [{ to: "/user/dashboard", label: isEnglish ? "Dashboard & automation" : "داشبورد و ارسال خودکار", icon: LayoutDashboard }, { to: "/user/userEmailes", label: isEnglish ? "Email reports" : "گزارش ایمیل‌ها", icon: MailCheck }, { to: "/user/jobs", label: isEnglish ? "Job applications" : "درخواست‌های شغلی", icon: BriefcaseBusiness }];
  const signOut = () => {
    const cookies = new Cookies();
    cookies.remove("role", { path: "/" }); cookies.remove("token", { path: "/" }); cookies.remove("name", { path: "/" });
    navigate("/");
  };
  return <aside className={`workspace-sidebar ${open ? "is-open" : ""}`}>
    <Link className="workspace-brand" to="/" onClick={onClose}><span className="workspace-infinity" aria-hidden="true">∞</span><div><strong>Infinity Apply</strong><span>{isEnglish ? "International journey workspace" : "پنل مسیر بین‌المللی"}</span></div></Link>
    <nav>{links.map(({ to, label, icon: Icon }) => <NavLink key={to} to={to} onClick={onClose} className={({ isActive }) => isActive ? "is-active" : ""}><Icon size={18} /><span>{label}</span></NavLink>)}</nav>
    <div className="workspace-sidebar-foot"><button onClick={toggleLanguage}><Languages size={18} />{isEnglish ? "فارسی" : "English"}</button><Link to="/" onClick={onClose}><Home size={18} />{isEnglish ? "Back to website" : "بازگشت به سایت"}</Link><button onClick={signOut}><LogOut size={18} />{isEnglish ? "Sign out" : "خروج از حساب"}</button></div>
  </aside>;
};

export default UserSidebar;
